export default __webpack_public_path__ + "static/media/137.247dd270.png";